import React, { useState } from "react";
import cx from "clsx";

import CloseSvg from "@/images/shared/close-x.svg";

import globalStyles from "@/styles/global.module.scss";
import styles from "./modalClosebutton.module.scss";

const ModalCloseButton = props => {
  const { isDesktop, onClick, containerClassName } = props;

  const [hovered, setHovered] = useState(false);
  const memoHover = val => () => setHovered(val);

  return (
    <div
      className={cx(
        styles.closeContainer,
        isDesktop && styles.isDesktop,
        containerClassName
      )}
    >
      <div className={styles.buttonInner}>
        <button
          onClick={onClick}
          className={cx(globalStyles.buttonReset, styles.button)}
          onMouseOver={memoHover(true)}
          onMouseOut={memoHover(false)}
          onFocus={memoHover(true)}
          onBlur={memoHover(false)}
        >
          <CloseSvg
            alt="Close"
            width={26}
            height={26}
            className={cx(
              // globalStyles.image,
              hovered ? styles.hovered : styles.default
            )}
          />
        </button>
      </div>
    </div>
  );
};

export default ModalCloseButton;
